<!-- Textual Inputs -->
<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                Utente
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form #userForm="ngForm">
            @if (user) {
                <div class="mb-25">
                    <div class="row">
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Username</mat-label>
                                <input
                                  #name='ngModel'
                                    matInput
                                  placeholder="Username"
                                    name="username"
                                    [(ngModel)]="user.username"
                                  required
                                    minlength="3"
                                >
                                @if (name.hasError('required')) {
                                    <mat-error>Username è <strong>obbligatoria</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Email</mat-label>
                              <input
                                #email='ngModel'
                                type="email"
                                matInput
                                placeholder="Email"
                                name="email"
                                [(ngModel)]="user.email"
                                email
                                    required
                                >
                                @if (email.hasError('email') && !email.hasError('required')) {
                                    <mat-error>Formato email non corretto</mat-error>
                                }
                                @if (email.hasError('required')) {
                                    <mat-error>Email è <strong>obbligatoria</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Telefono</mat-label>
                                <input #phone="ngModel" matInput placeholder="Telefono" name="phone" id="phone" [(ngModel)]="user.phone">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Nome</mat-label>
                                <input matInput placeholder="Nome" name="name" id="name"
                                       [(ngModel)]="user.name">
                            </mat-form-field>
                        </div>
                        <div class="col col-4">
                            <mat-form-field class="mb-25">
                                <mat-label>Cognome</mat-label>
                                <input matInput placeholder="Cognome" name="surname" id="surname"
                                       [(ngModel)]="user.surname">
                            </mat-form-field>
                        </div>
                        <div class="col col-4">
                            <mat-form-field>
                              <mat-label>Tipo account</mat-label>
                                <mat-select name="accountType" [(ngModel)]="user.accountType" id="accountType">
                                    <mat-option *ngFor="let type of userTypes" [value]="type">{{ getEnumDescription(type) }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            }
            <mat-divider class="mb-25"></mat-divider>
            <mat-card-footer>
                <div class="row d-flex flex-row">
                    <div class="col col-3 d-flex flex-column text-start">
                        @if (user && user.creationDate) {
                            <small class="badge rounded-pill text-soft-primary mb-5">Creato il
                                <strong>{{ user.creationDate }}</strong> </small>
                        }
                        @if (user && user.updateDate) {
                            <small class="badge rounded-pill text-soft-primary mb-5">Modificato il
                                <strong>{{ user.updateDate }}</strong> </small>
                        }
                    </div>
                    <div class="footer-buttons d-flex col-9">
                        <button mat-raised-button color="warn" class="btn " [routerLink]="['/users']">
                            <mat-icon>close</mat-icon>
                            Annulla
                        </button>
                        <button type="button" mat-raised-button class="btn daxa"
                                [disabled]="userForm.invalid"
                                (click)="saveAndResetPsw(userForm)">
                            <mat-icon>email</mat-icon>
                            Salva e invia nuova password
                        </button>
                        <button type="submit" mat-raised-button class="btn daxa"
                                [disabled]="userForm.invalid"
                                (click)="onSubmitForm( userForm)">
                            <mat-icon>check</mat-icon>
                            Salva e chiudi
                        </button>
                    </div>
                </div>
            </mat-card-footer>
        </form>
    </mat-card-content>
</mat-card>



